import { createModalFlow } from 'src/utils/flow'

export const flowConfig = {
  initial: 'entry',
  states: {
    entry: {
      on: {
        initial: 'AccountChooserModal',
        signUp: 'SignUpModal'
      }
    },
    exit: {},
    finish: {},
    AccountChooserModal: {
      on: {
        exit: 'exit',
        logIn: 'LogInModal',
        signUp: 'SignUpModal'
      }
    },
    LogInModal: {
      on: {
        prev: 'AccountChooserModal',
        passwordResetConfirmation: 'PasswordResetConfirmationModal',
        signUp: 'SignUpModal',
        finish: 'finish'
      }
    },
    SignUpModal: {
      on: {
        prev: 'AccountChooserModal',
        finish: 'finish'
      }
    },
    PasswordResetConfirmationModal: {
      on: {
        prev: 'LogInModal',
        passwordReset: 'PasswordResetModal'
      }
    },
    PasswordResetModal: {
      on: {
        login: 'LogInModal'
      }
    }
  }
}

export default createModalFlow(flowConfig)
